import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7dc5eb48"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["xlink:href"]

import { computed } from 'vue'

const __default__ = {
  name: "SvgIcon"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  iconClass: {
    type: String,
    required: true
  },
  className: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props;


const iconName = computed(() => `#icon-${props.iconClass}`)
const svgClass = computed(() => 'svg-icon')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: _normalizeClass(_unref(svgClass)),
    "aria-hidden": "true"
  }, [
    _createElementVNode("use", { "xlink:href": _unref(iconName) }, null, 8, _hoisted_1)
  ], 2))
}
}

})